<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
          <div class="row">
            <div class="col-9">
              <h4 class="text-green d-inline-block m-0 align-middle">
                選擇撥入單位
              </h4>
              <div class="tags d-inline-block">
                <div class="tag" key="dialin-tag">
                  {{ RouterPara.seniormanagerTabOne.dialInSelected.div_short_name }}
                  {{ RouterPara.seniormanagerTabOne.dialInSelected.ceempnm }}
                  {{ RouterPara.seniormanagerTabOne.dialInSelected.clcno }}
                </div>
              </div>
            </div>
            <div class="col-3 text-right">
              <span class="text label"
                >已選：{{ this.computedCount.householdCount }}戶 /
                {{ this.computedCount.ceapcnoCount }}件</span
              >
            </div>
          </div>
        </div>
        <hr />
        <form class="form">
          <div class="container">
            <section class="insurance-table newTable">
              <div :class="{ 'section-loading': isInsertApiLoading }">
                <table class="table datatable table-striped table-bordered">
                  <thead>
                    <tr>
                      <th width="60">
                        <div class="checkbox checkbox-inline mr-0">
                          <input
                            type="checkbox"
                            :name="`check-all`"
                            :id="`check-all`"
                            v-model="checkAll"
                            @click="checkAllClick = true"
                          />
                          <label :for="`check-all`"></label>
                        </div>
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceplcno'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceplcno')"
                      >
                        保單號碼
                      </th>
                      <th width="120"
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceapcnm'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceapcnm')"
                      >
                        客戶姓名
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceclcno'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceclcno')"
                      >
                        現行收<br />費人員
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'clcno_chg_date'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('clcno_chg_date')"
                      >
                        撥入日期
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'd2_payaddr'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('d2_payaddr')"
                      >
                        整合地址
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'celpscs_nm'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('celpscs_nm')"
                      >
                        契約<br />效力
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'apc_id_tags'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('apc_id_tags')"
                      >
                        提供直<br />效撥打
                      </th>
                      <!-- <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceclcnm_old'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceclcnm_old')"
                      >
                        前一收<br />費人員
                      </th> -->
                      <!-- <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'intr_name'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('intr_name')"
                      >
                        增員者
                      </th> -->
                      <th width="100"
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceagnnm'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceagnnm')"
                      >
                        經手人
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'other_ceclcnm_area'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('other_ceclcnm_area')"
                      >
                        其他收<br />費人員
                      </th>
                      <!-- <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'cenxpdt'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('cenxpdt')"
                      >
                        下次<br />應繳日
                      </th> -->
                      <!-- <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'deadline'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('deadline')"
                      >
                        調撥<br />截止日
                      </th> -->
                    </tr>
                  </thead>
                  <tbody v-if="searchResult.length && !listLoading">
                    <tr
                      v-for="(item, index) in searchResult"
                      :key="`result-table-${index}-${item.ceplcno}`"
                    >
                      <td>
                        <div class="mr-0 checkbox checkbox-inline">
                          <input
                            type="checkbox"
                            :name="`result-table-td-item`"
                            :id="`result-table-${index}`"
                            v-model="resultSelection"
                            @click="checkAllClick = false"
                            @change="updateSelected(item, index)"
                            :value="index"
                          />
                          <label :for="`result-table-${index}`"></label>
                        </div>
                      </td>
                      <td width="125px">{{ item.ceplcno }}</td>
                      <td width="120px">
                        <span>
                          <span
                            class="d-inline-block text-center align-middle mr-1"
                          >
                            <level :lv="Number(item.vip)" /><br />
                            <avatar
                              :gender="Number(item.ceapcno[1])"
                              :size="20"
                            />
                          </span>
                          <span class="name align-middle">
                            {{ item.ceapcnm }}
                          </span>
                        </span>
                      </td>
                      <td width="100px">
                        {{ item.ceclcnm }}<br />{{ item.ceclcno }}
                      </td>
                      <td width="105px">{{ item.clcno_chg_date || "" }}</td>
                      <td width="160px">
                        {{ item.zip_code ? item.zip_code : ""
                        }}{{ item.d2_payaddr }}
                      </td>
                      <td>{{ item.celpscs_nm }}</td>
                      <td>{{ item.apc_id_tags }}</td>
                      <!-- <td width="95px">
                        {{ item.ceclcnm_old ? item.ceclcnm_old : "" }}<br />{{
                          item.ceclcno_old ? item.ceclcno_old : ""
                        }}
                      </td> -->
                      <!-- <td width="80px">
                        {{ item.intr_name ? item.intr_name : "" }}
                      </td> -->
                      <td width="100px">
                        {{ item.ceagnnm ? item.ceagnnm : "" }}
                      </td>
                      <td width="100px">
                        {{ item.other_ceclcnm_area ? item.other_ceclcnm_area : ""
                        }}<br />{{
                          item.other_ceclcno_area ? item.other_ceclcno_area : ""
                        }}
                      </td>
                      <!-- <td width="105px">{{ item.cenxpdt | dateFormat }}</td>
                      <td width="105px">{{ item.deadline | dateFormat }}</td> -->
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td :colspan="10" class="empty-block bg-white">
                        <h3 v-if="!listLoading" class="bg-white">查無資料</h3>
                        <h3 v-else class="bg-white">
                          <div
                            class="section-loading d-inline-block"
                            style="height:20px; width:30px"
                          ></div>
                          資料讀取中...
                        </h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-6">
              </div>
              <div class="col-6 text-right">
                <router-link
                  :to="'/seniormanager/tab/1'"
                  class="btn btn-default"
                >
                  上一步
                </router-link>
                <a class="btn btn-primary" @click="doConfirm()">
                  下一步
                </a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <warning-modal
      :open="warnModalOpen"
      :message="warnModalMsg"
      :showCancel="warnCancelShow"
      :buttonDisabled="buttonDisabled"
      :confirmText="confirmText"
      @submit="doSubmitMethod"
      @close="panelClose('warnModalOpen')"
    />
    <count-warning-modal
      :open="countModalOpen"
      :message="countModalMsg"
      @close="panelClose('countModalOpen')"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import DialOutPersonModal from "@/desktop/components/manager/DialOutPersonModal";
import DialInPersonModal from "@/desktop/components/manager/DialInPersonModal";
import TabHeader from "@/desktop/components/manager/TabHeader";
import WarningModal from "@/desktop/components/WarningModal";
import CountWarningModal from "@/desktop/components/CountWarningModal";
import Avatar from "@/components/Avatar";
import Level from "@/components/Level";
import { debuglog, log } from "util";
import {
  queryAllocationList,
  queryDistByCity,
  getGoogleMapLocation,
  insertServiceRecord,
  queryDivLatLnt
} from "@/service";

export default {
  name: "TransferTab1Filter",
  mixins: [commonMixin],
  components: {
    TabHeader,
    DialOutPersonModal,
    DialInPersonModal,
    WarningModal,
    CountWarningModal,
    Level,
    Avatar
  },
  computed: {
    ...mapGetters(["Cities", "RouterPara", "UserRight"]),
    // 計算列表模式 type 6 件數
    limitCount() {
      //過濾重覆id計算當日上限
      let nolyOneId = [];
      let filterAry = this.searchResult.filter((item, index) => {
        return this.resultSelection.includes(index);
      });
      filterAry.forEach(item => {
        if (!nolyOneId.includes(item.ceapcno)) {
          nolyOneId.push(item.ceapcno);
        }
      });
      return nolyOneId.length;
    },
    // 監聽相關欄位 Disable
    chargerDisable() {
      return this.inteSelect.charger[0] == "";
    },
    distDisable() {
      return this.inteSelect.address[0] == "";
    },
    addressDisable() {
      return this.inteSelect.address[1] == "";
    },
    distDisableMap() {
      return this.mapSelect.address[0] == "";
    },
    addressDisableMap() {
      return this.mapSelect.address[1] == "";
    },
    // 計算件數/戶數(戶數是客戶id數、件數是保單ID)
    computedCount() {
      var ceapcnoList = [];
      this.searchResult.forEach((item, index) => {
        if (this.resultSelection.includes(index)) {
          ceapcnoList.push(item.ceapcno);
        }
      });
      return {
        ceapcnoCount: ceapcnoList.length,
        householdCount: [...new Set(ceapcnoList)].length
      };
    }
  },
  data() {
    return {
      isInsertApiLoading: false,
      inAgentInfo: {},
      warnModalOpen: false,
      countModalOpen: false,
      countModalMsg: "",
      countCancelShow: false,
      checkAllClick: false,
      listLoading: false,
      warnModalMsg: "",
      resultSelection: [],
      originalCount: "",
      checkType: false,
      warnCancelShow: true,
      warnMethodName: "",
      buttonDisabled: false,
      confirmText: "確定",
      infoWin: {
        options: {
          pixelOffset: {
            width: 0,
            height: -45
          },
          disableAutoPan: true
        },
        pos: null,
        open: false,
        ceapcnm: "",
        d2_payaddr: "",
        ceclcnm: "",
        markerIndex: 0
      },
      currentMidx: null,
      unfilteredMarkers: [],
      originMarkers: [],
      markers: [],
      cityList: [],
      distLsit: [],
      distLsitForMap: [],
      originResult: [],
      inteSelect: {
        clientName: "",
        charger: ["", ""],
        vip: "",
        self: "",
        address: ["", "", ""]
      },
      mapSelect: {
        clientName: "",
        address: ["", "", ""]
      },
      form: {
        dialOut: [],
        dialIn: [],
        selected: []
      },
      nameList: [],
      countList: [],
      checkAll: false,
      searchResult: [],
      condictions: {
        cedvno3: "",
        type: "",
        clcno_old: "",
        ceplcno: "",
        ceapcno: "",
        zip: "",
        addr: "",
        segment_old: "",
        clcno_old_list: "",
        clcno_new: "",
        cusname: "",
        now_ex: "",
        ceclcnm: "",
        is_vip: "",
        ceagent: "",
        zip_filter: "",
        addr_filter: "",
        selected_plcno: ""
      },
      order: {
        fieldName: "",
        asc: true
      },
      fromPath: '' //前一個頁面路由的路徑
    };
  },
  watch: {
    checkAll(val) {
      this.doAll(val);
    },
  },
  methods: {
    ...mapActions(["setPageLock"]),
    doAll(val) {
      // 跟 selected 連動
      if (val && this.checkAllClick) {
        this.resultSelection = [];
        this.searchResult.forEach((data, index) => {
          this.resultSelection.push(index);
        });
        this.checkIdmarkType(this.searchResult);
        this.checkType = true;
      } else if (this.checkAllClick) {
        this.resultSelection = [];
      }
    },
    updateSelected(custData, clickIndex) {
      const selectedHasVal = this.resultSelection.includes(clickIndex);
      if (selectedHasVal) {
        // 選取陣列已有該客戶ID
        this.checkIdmarkType(custData);
        this.checkType = true;
        this.searchResult.forEach((item, index) => {
          // 連動服務件列表客戶 ID
          if (!this.resultSelection.includes(index)) {
            if (custData.ceapcno === item.ceapcno) {
              // 連動新增
              this.resultSelection.push(index);
            }
          }
        });
      } else {
        // 選取陣列無該客戶ID
        this.checkType = false;
        this.searchResult.forEach((item, index) => {
          // 連動刪除
          if (custData.ceapcno === item.ceapcno) {
            this.resultSelection = this.resultSelection.filter(item => {
              return item !== index;
            });
          }
        });
      }

      // 跟 checkAll 連動
      if (
        this.searchResult.length !== this.resultSelection.length &&
        !this.checkAllClick
      ) {
        this.checkAll = false;
      } else if (!this.checkAllClick) {
        this.checkAll = true;
      }
    },
    checkIdmarkType(val) {
      //判斷idmark是否為密戶
      if (this.resultSelection.length == val.length) {
        let isScr = false;
        this.nameList = [];
        const set = new Set();
        let idByList = [];
        idByList = val.filter(item =>
          !set.has(item.ceapcno) ? set.add(item.ceapcno) : false
        ); // 過濾重覆ID
        idByList.forEach((item, index) => {
          if (item.idmark.includes("S")) {
            this.nameList.push(item.ceapcnm);
            isScr = true;
          }
        });
        if (isScr) {
          // this.setToastMsg(`保戶${this.nameList}為「密戶」，請再確認是否要更換服務人員`)
          this.warnModalMsg = `保戶${this.nameList}為「密戶」，請再確認是否要更換服務人員`;
          this.warnMethodName = "removeMarker";
          this.warnCancelShow = false;
          this.panelOpen("warnModalOpen");
        }
      } else if (
        this.resultSelection.length != val.length &&
        val.idmark.indexOf("S") >= 0
      ) {
        // this.setToastMsg(`保戶${val.ceapcnm}為「密戶」，請再確認是否要更換服務人員`)
        this.warnModalMsg = `保戶${val.ceapcnm}為「密戶」，請再確認是否要更換服務人員`;
        this.warnMethodName = "removeMarker";
        this.warnCancelShow = false;
        this.panelOpen("warnModalOpen");
      }
    },
    removeMarker() {
      // 移除 marker info
      this.panelClose("warnModalOpen");
      this.markers.splice(this.infoWin.markerIndex, 1);
      this.infoWin.open = !this.infoWin.open;
      this.checkIn();
    },
    closeWindow() {
      // 關閉 marker info
      this.infoWin.open = !this.infoWin.open;
    },
    toggleInfoWindow(marker, idx) {
      // 切換 marker info 並更新資訊
      this.infoWin.pos = marker.position; // 設定視窗位置

      // for 難字 update
      this.infoWin.ceapcnm = ""; // 設定要　保　人
      this.infoWin.d2_payaddr = ""; // 設定地　　　址
      this.infoWin.ceclcnm = ""; // 設定服 務 人 員

      setTimeout(() => {
        this.infoWin.ceapcnm = marker.ceapcnm; // 設定要　保　人
        this.infoWin.d2_payaddr = marker.d2_payaddr; // 設定地　　　址
        this.infoWin.ceclcnm = marker.ceclcnm; // 設定服 務 人 員
        this.registerHanlink();
      }, 100);

      this.infoWin.markerIndex = idx;
      if (this.currentMidx == idx) {
        this.infoWin.open = !this.infoWin.open;
      } else {
        this.infoWin.open = true;
        this.currentMidx = idx;
      }
    },
    doSubmitMethod() {
      this[this.warnMethodName]();
    },
    doRemind(){
      this.warnModalMsg = "【調撥申請已送出】";
      this.warnMethodName = "doSubmit";
      this.warnCancelShow = false;
      this.panelOpen("warnModalOpen");
    },
    doSubmit() {
      // 下一步寫入紀錄
      // Call API
      if (this.buttonDisabled) {
        return;
      }

      this.buttonDisabled = true;
      this.confirmText = "處理中...";

      const typeCondition = this.RouterPara.seniormanagerTabOne.condictions.type;
      let policyList = this.searchResult.filter((item, index) => {
        // 過濾以選擇list
        return this.resultSelection.includes(index);
      });
      this.isInsertApiLoading = true;
      insertServiceRecord(
        this.$store.state.userInfo.id,
        typeCondition,
        policyList,
        this.inAgentInfo,
        this.RouterPara.seniormanagerTabOne.dialInCode,
        this.$store.state.userInfo.name
      ).then(result => {
        this.buttonDisabled = false;
        this.confirmText = "確定";

        if (result.header && result.header.status === "200") {
          this.$toast.info({ title: "跨單位調撥已完成！" });
          this.$router.push({ path: "/seniormanager/tab/1" });
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "系統連線異常,請稍後再試" });
          }
        }
        this.isInsertApiLoading = false;
      });

      this.panelClose("warnModalOpen");
    },
    doConfirm() {
      if (this.resultSelection.length == 0) {
          return this.$toast.info({ title: "請至少選擇一位客戶" });
      }

        // 如果是 condictions.type 為 6 時 每日調撥上限為50位客戶
      if (
          this.limitCount + Number(this.originalCount) > 50 &&
          this.RouterPara.seniormanagerTabOne.condictions.type == "6"
      ) {
          return this.setToastMsg(
            `每日調撥上限為50位客戶，您勾選的客戶人數已超過上限${this
              .limitCount +
              Number(this.originalCount) -
              50}位。`
          );
      }

      this.warnModalMsg = "你是否確認要進行跨單位調撥？";
      this.warnMethodName = "doRemind";
      this.warnCancelShow = true;
      this.panelOpen("warnModalOpen");
    },
    doCheckAll(val) {
      if (!val) this.form.selected = [];
      else
        this.searchResult.forEach(r => {
          this.form.selected.push(r.id);
        });
    },
    updateSelection(selection) {
      this.resultSelection = selection;
    },
    queryDist() {
      this.inteSelect.address[1] = "";
      this.inteSelect.address[2] = "";
      this.distLsit = [];
      if (this.inteSelect.address[0] == "") {
        return false;
      }
      queryDistByCity(
        this.$store.state.userInfo.id,
        this.inteSelect.address[0]
      ).then(distdata => {
        if (distdata && distdata.header && distdata.header.status === "200") {
          this.distLsit = distdata.body.cityAreaList;
        } else {
          console.error("取得鄉鎮市區失敗 method: queryDistByCity");
        }
      });
    },
    queryDistForMap() {
      this.mapSelect.address[1] = "";
      this.mapSelect.address[2] = "";
      this.distLsitForMap = [];
      if (this.mapSelect.address[0] == "") {
        return false;
      }
      queryDistByCity(
        this.$store.state.userInfo.id,
        this.mapSelect.address[0]
      ).then(distdata => {
        if (distdata && distdata.header && distdata.header.status === "200") {
          this.distLsitForMap = distdata.body.cityAreaList;
        } else {
          console.error("取得鄉鎮市區失敗 method: queryDistByCity");
        }
      });
    },
    listFilter() {
      // 整合篩選過濾
      this.searchResult = [...this.originResult];
      // 過濾客戶姓名  clientName
      if (this.inteSelect.clientName !== "") {
        this.searchResult = this.searchResult.filter(item => {
          return item.ceapcnm.includes(this.inteSelect.clientName);
        });
      }
      // 過濾收費人員  charger
      if (
        this.inteSelect.charger[0] !== "" &&
        this.inteSelect.charger[1] !== ""
      ) {
        if (this.inteSelect.charger[0] == "now") {
          // 過濾現行人員
          this.searchResult = this.searchResult.filter(item => {
            return item.ceclcnm.includes(this.inteSelect.charger[1]);
          });
        }
        if (this.inteSelect.charger[0] == "past") {
          // 過濾前一人員
          this.searchResult = this.searchResult.filter(item => {
            if (item.ceclcnm_old) {
              return item.ceclcnm_old.includes(this.inteSelect.charger[1]);
            }
          });
        }
      }
      // 過濾VIP  vip
      if (this.inteSelect.vip !== "") {
        this.searchResult = this.searchResult.filter(item => {
          return item.idmark.includes(this.inteSelect.vip);
        });
      }
      // 過濾自招  ceagent
      if (this.inteSelect.self !== "") {
        this.searchResult = this.searchResult.filter(item => {
          return item.ceagent.includes(this.inteSelect.self);
        });
      }
      // 過濾整合地址  address
      if (this.inteSelect.address[0] !== "") {
        let allAddress =
          this.inteSelect.address[0] + this.inteSelect.address[1];
        this.searchResult = this.searchResult.filter(item => {
          return item.d2_payaddr.includes(allAddress);
        });
      }

      if (this.inteSelect.address[2] !== "") {
        let allAddress = this.inteSelect.address[2];
        this.searchResult = this.searchResult.filter(item => {
          return item.d2_payaddr.includes(allAddress);
        });
      }

      // 難字 update
      let copyAry = [...this.searchResult];
      this.searchResult = [];
      this.resultSelection = [];
      setTimeout(() => {
        this.searchResult = copyAry;
        this.registerHanlink();
      }, 100);
    },
    initAllocationList() {
      this.exercuteAllocationTab1()
    },
    exercuteAllocationTab1(){
      this.condictions = this.RouterPara.seniormanagerTabOne.condictions;
      this.queryAllocationList(this.condictions);
      this.cityList = [...this.Cities];
      setTimeout(() => {
        this.registerHanlink(); //難字 update
      }, 50);
    },
    returnIndex() {
      this.panelClose("warnModalOpen");
      let roleId = this.$store.state.userInfo.roleId || "";
      if (roleId == "SALES_MANAGER_02" || roleId == "SALES_MANAGER_06") {
        //  如果是大主管
        this.$router.push({ name: "transfer-tab1" });
      } else {
        //  如果是小主管
        this.$router.push({ name: "sub-transfer-tab-1" });
      }
    },
    queryAllocationList(condictions) {
      //呼叫服務件列表API
      this.listLoading = true;
      queryAllocationList(this.$store.state.userInfo.id, condictions).then(
        result => {
          if (result && result.header && "200" === result.header.status) {
            this.listLoading = false;
            if (result.body && result.body.policy_list) {
              this.inAgentInfo = result.body.inag_info;
              this.originResult = result.body.policy_list;
              console.log("result.body.policy_list", result.body.policy_list);
              this.originResult.forEach(data => {
                if (data.cenxpdt === "1911-01-01") {
                  // 判別日期
                  data.cenxpdt = "";
                }
                if (data.idmark) {
                  if (data.idmark.includes("G")) {
                    // 判別VIP 黃金
                    data.vip = 5;
                  } else if (data.idmark.includes("P")) {
                    // 判別VIP 白金
                    data.vip = 6;
                  } else if (data.idmark.includes("D")) {
                    // 判別VIP 鑽石
                    data.vip = 7;
                  }
                } else {
                  data.idmark = "";
                  data.vip = 0;
                }
              });
              this.searchResult = [...this.originResult]; // 拷貝一份當參考

              if (this.RouterPara.seniormanagerTabOne.condictions.type == "6") {
                this.originalCount = result.body.limit.count; // 記錄原始單日上限
              }

              // 針對地址查詢 超過4000件保單 返回首頁
              if (
                result.body.rows != "" &&
                Number(result.body.rows) > 4000 &&
                condictions.type == "4"
              ) {
                this.warnModalMsg =
                  "此條件查詢到超過4000件保單，請輸入詳細地址可以更容易找到您所要分配的服務件!";
                this.warnMethodName = "returnIndex";
                this.warnCancelShow = false;
                this.panelOpen("warnModalOpen");
              }

              // 預設勾選
              this.searchResult.forEach((e, index) => {
                if (e.resign_agent == "1" && !e.mgr_id) {
                  this.resultSelection.push(index);
                }
              });
            }
          } else {
            this.$toast.info({ title: result.header.message });
            this.searchResult = [];
          }
          this.registerHanlink(); // 難字 update
        }
      );
    },
    processSearchResult(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      this.listLoading = true;
      setTimeout(() => {
        this.searchResult.sort(this.sortCompareFun(sortOrder, fieldName));
        this.listLoading = false;
        this.registerHanlink(); // 難字顯示
      }, 20);
    },
    sortCompareFun(sortOrder, property) {
      if (property === `ceclcnm_old` || `ceagnnm` || `other_ceclcnm`) {
        return function(a, b) {
          let a_value = a[property] ? a[property] : "";
          let b_value = b[property] ? b[property] : "";
          let result = a_value < b_value ? -1 : a_value > b_value ? 1 : 0;
          return result * sortOrder;
        };
      } else if (property === "cenxpdt" || property === "deadline") {
        let cVue = this;
        return function(a, b) {
          var a_value =
            cVue.$options.filters.dateFormat(a[property]) != `— —`
              ? a[property]
              : ``;
          var b_value =
            cVue.$options.filters.dateFormat(b[property]) != `— —`
              ? b[property]
              : ``;

          let result = a_value < b_value ? -1 : a_value > b_value ? 1 : 0;
          return result * sortOrder;
        };
      } else {
        return function(a, b) {
          let result =
            a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
          return result * sortOrder;
        };
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPath = from.path
    })
  },
  mounted() {
    this.initAllocationList();
  }
};
</script>
